var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandRight = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 14,
  fill: "currentColor",
  viewBox: "0 0 8 14",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  d: "m7 7 .354-.354.353.354-.353.354zM1.354.646l6 6-.708.708-6-6zm6 6.708-6 6-.708-.708 6-6z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandRight);
export default ForwardRef;